// extracted by mini-css-extract-plugin
export default {"snackbar":"SIjI","typography":"raoD"};